if (!customElements.get("da-product-modal")) {
  customElements.define(
    "da-product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.imgViewer = document.getElementById("product_img");

        this.imgs = Array.from(this.querySelectorAll(".right-images img"));
        this.imgs.forEach((img) => {
          img.addEventListener("click", () => {
            this.setActiveImg(img);
          });
        });

        this.nextButton = document.getElementById("imageRightButton");
        this.prevButton = document.getElementById("imageLeftButton");

        this.prevButton.addEventListener("click", (e) => {
          this.showNextImage(false);
        });
        this.nextButton.addEventListener("click", (e) => {
          this.showNextImage(true);
        });

        this.isMoving = false;
        this.offsetX = 0;
        this.offsetY = 0;
        this.setZoomButton();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        if (window.innerWidth > 749) {
          super.show(opener);
          this.showActiveMedia();
        }
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute(
            "data-media-id"
          )}"])`
        ).forEach((element) => {
          element.classList.remove("active");
        });

        const activeMedia = this.querySelector(
          `[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`
        );
        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate
          ? activeMediaTemplate.content
          : null;
        activeMedia.classList.add("active");

        this.activeImg = activeMedia;

        this.imgViewer.setAttribute(
          "srcset",
          activeMedia.getAttribute("srcset")
        );
        // this.resetZoom();
        // console.log(activeMedia);
        /*
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == "DEFERRED-MEDIA" &&
          activeMediaContent &&
          activeMediaContent.querySelector(".js-youtube")
        )
          activeMedia.loadContent();
        */
      }

      showNextImage(isNext) {
        var idx = this.imgs.findIndex(
          (x) =>
            x.getAttribute("data-media-id") ==
            this.activeImg.getAttribute("data-media-id")
        );
        if (isNext) {
          if (idx == this.imgs.length - 1) idx = 0;
          else idx += 1;
        } else {
          if (idx == 0) idx = this.imgs.length - 1;
          else idx -= 1;
        }

        this.activeImg = this.imgs[idx];
        this.setActiveImg(this.imgs[idx]);
      }

      setActiveImg(img) {
        this.imgs.forEach((t) => {
          t.classList.remove("active");
        });
        img.classList.add("active");
        this.activeImg = img;
        this.imgViewer.setAttribute("srcset", img.getAttribute("srcset"));
        this.resetZoom();
      }

      setZoomButton() {
        this.zoomInButton = document.getElementById("ZoomInButton");
        this.zoomOutButton = document.getElementById("ZoomOutButton");
        this.zoomViewer = document.getElementById("zoomViewer");
        this.zoomValue = document.getElementById("ZoomValue");
        this.currentZoom = 1;
        this.imageContainer = document.getElementById("ProductImageContainer");

        this.zoomInButton.addEventListener("click", (e) => {
          if (this.currentZoom == 6) return;
          this.currentZoom++;
          this.zoomValue.innerText = `${(this.currentZoom - 1) * 20}%`;
          this.zoomViewer.style = `transform: scale(${this.currentZoom}) translate(0px, 0px);`;
        });
        this.zoomOutButton.addEventListener("click", (e) => {
          if (this.currentZoom == 1) return;
          this.currentZoom--;
          this.zoomValue.innerText = `${(this.currentZoom - 1) * 20}%`;
          this.zoomViewer.style = `transform: scale(${this.currentZoom}) translate(0px, 0px);`;
        });

        this.zoomViewer.addEventListener("mousedown", this.dragImage.bind(this)); // 添加鼠标按下事件监听器
        this.zoomViewer.addEventListener("mouseup", (e) => {
          this.isMoving = false;
          this.zoomViewer.removeEventListener("mousemove", this.moveImage.bind(this)); // 松开鼠标后停止移动
        }); // 添加鼠标松开事件监听器
      }

      resetZoom() {
        this.zoomViewer.style = ``;
        this.currentZoom = 1;
        this.zoomValue.innerText = `0%`;
      }
      //zoomViewer.addEventListener("dragstart", dragstartHandler);

      moveImage(event) {
        if (!this.isMoving) return;
        this.zoomViewer.style.left = event.clientX - this.offsetX + "px"; // 根据当前鼠标位置更新图片的水平位置
        this.zoomViewer.style.top = event.clientY - this.offsetY + "px"; // 根据当前鼠标位置更新图片的垂直位置

        if (event.type === "mouseup") {
          this.isMoving = false;
          this.zoomViewer.removeEventListener("mousemove", this.moveImage.bind(this)); // 松开鼠标后停止移动
        }
      }
      dragImage(event) {
        event.preventDefault(); // 阻止默认事件发生（比如选中文本）
        if (this.currentZoom == 1) return;
        this.isMoving = true;
        this.offsetX = event.clientX - event.currentTarget.offsetLeft; // 计算鼠标点击时与图片左边界之间的距离
        this.offsetY = event.clientY - event.currentTarget.offsetTop; // 计算鼠标点击时与图片上边界之间的距离

        this.zoomViewer.addEventListener("mousemove", this.moveImage.bind(this)); // 添加鼠标移动事件监听器
      }
    }
  );
}
